import React from 'react';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import { useTranslation } from 'react-i18next';
import { getDeviationPrice } from '../../../helpers';
import DetailsRightSide from '../../../layouts/DetailsRightSide';
import s from './AdoptableDetailsRightSide.scss';
const AdoptableDetailsRightSide = ({ deviation })=>{
    const { t } = useTranslation();
    const { dollarsPrice: fixedDollarsPrice, pointsPrice: fixedPointsPrice } = getDeviationPrice(deviation);
    if (!deviation.adoptable) {
        return null;
    }
    const { thumbSaleState, thumbSaleType } = deviation.adoptable;
    const isFixedPriceOnly = thumbSaleType === 'fixed';
    const isOffersOnly = thumbSaleType === 'offer';
    const isOffersAndFixedPrice = thumbSaleType === 'both';
    // default values we fallback to
    let firstRow = `$${parseInt(fixedDollarsPrice)}`;
    let secondRow = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PointsIcon, {
        size: IconSize.TINY,
        disableDefaultColors: true
    }), fixedPointsPrice);
    if (isFixedPriceOnly) {
        // FIXED PRICE
        if (thumbSaleState === 'unlisted') {
            // Unlisted
            secondRow = /*#__PURE__*/ React.createElement("div", {
                className: s['warning']
            }, t('shop.thumb.adoptable.status.saleEnded'));
        } else if (thumbSaleState === 'sold') {
            // Sold
            secondRow = /*#__PURE__*/ React.createElement("div", {
                className: s['warning']
            }, t('shop.thumb.adoptable.status.sold'));
        }
    } else if (isOffersOnly) {
        var _deviation_adoptable_offers, _deviation_adoptable;
        // OFFERS
        const offerPrice = (_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : (_deviation_adoptable_offers = _deviation_adoptable.offers) === null || _deviation_adoptable_offers === void 0 ? void 0 : _deviation_adoptable_offers.offerPrice;
        if (thumbSaleState === 'open') {
            // Open
            firstRow = `$${offerPrice}`;
            secondRow = t('shop.thumb.adoptable.CTA.startingOffer');
        } else if (thumbSaleState === 'pending') {
            // Pending
            firstRow = t('shop.thumb.adoptable.CTA.offersLocked');
            secondRow = t('shop.thumb.adoptable.status.pending');
        } else if (thumbSaleState === 'expired') {
            // Expired
            firstRow = /*#__PURE__*/ React.createElement(React.Fragment, null, " ");
            secondRow = /*#__PURE__*/ React.createElement("div", {
                className: s['warning']
            }, t('shop.thumb.adoptable.status.expired'));
        } else if (thumbSaleState === 'unlisted') {
            // Unlisted
            firstRow = /*#__PURE__*/ React.createElement(React.Fragment, null, " ");
            secondRow = /*#__PURE__*/ React.createElement("div", {
                className: s['warning']
            }, t('shop.thumb.adoptable.status.saleEnded'));
        } else if (thumbSaleState === 'sold') {
            // Sold
            firstRow = `$${offerPrice}`;
            secondRow = /*#__PURE__*/ React.createElement("div", {
                className: s['warning']
            }, t('shop.thumb.adoptable.status.sold'));
        }
    } else if (isOffersAndFixedPrice) {
        // OFFERS & FIXED PRICE
        if (thumbSaleState === 'open') {
            // Open
            firstRow = t('shop.thumb.adoptable.CTA.bestOffer');
            secondRow = `or $${parseInt(fixedDollarsPrice)}`;
        } else if (thumbSaleState === 'pending') {
            // Pending
            firstRow = `$${fixedDollarsPrice}`;
            secondRow = t('shop.thumb.adoptable.CTA.buyItNow');
        } else if (thumbSaleState === 'expired') {
            // Expired
            firstRow = `$${parseInt(fixedDollarsPrice)}`;
            secondRow = t('shop.thumb.adoptable.CTA.buyItNow');
        } else if (thumbSaleState === 'unlisted') {
            // Unlisted
            firstRow = /*#__PURE__*/ React.createElement(React.Fragment, null, " ");
            secondRow = /*#__PURE__*/ React.createElement("div", {
                className: s['warning']
            }, t('shop.thumb.adoptable.status.saleEnded'));
        } else if (thumbSaleState === 'sold') {
            // Sold
            firstRow = `$${fixedDollarsPrice}`;
            secondRow = /*#__PURE__*/ React.createElement("div", {
                className: s['warning']
            }, t('shop.thumb.adoptable.status.sold'));
        }
    }
    return /*#__PURE__*/ React.createElement(DetailsRightSide, {
        firstRow: firstRow,
        secondRow: secondRow,
        secondRowClassName: s['row-gap']
    });
};
AdoptableDetailsRightSide.displayName = 'AdoptableDetailsRightSide';
export default AdoptableDetailsRightSide;
